<div class="card main-card mt-3 card-primary">
  <div class="card-header text-uppercase">
    {{title}}
  </div>
  <div class="card-body">
  
    <div class="row">
      <div class="col-lg-12">
        <!-- <ul class="nav nav-pills nav-fill mb-3 w-100 justify-content-center" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link" id="pills-personal-tab" data-toggle="pill"
               routerLink="/applicant/info/personal/basic" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
               role="tab" aria-controls="pills-personal" aria-selected="true">Personal Information</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" id="pills-contact-tab" data-toggle="pill"
               routerLink="/applicant/info/personal/contact" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
               role="tab" aria-controls="pills-contact"
               aria-selected="false">Contact Information</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" id="pills-info-tab" data-toggle="pill"
               routerLink="/applicant/info/personal/guardian" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
               role="tab" aria-controls="pills-info" aria-selected="false">Parent / Guardian's Information</a>
          </li>

        </ul> -->

          <div class="tab-content" id="pills-tabContent">

            <router-outlet></router-outlet>

          </div>

      </div>
    </div>
  </div>
</div>

